import React from "react";

export const TryHint = () => (
  <div>
    <h1>Что такое раздел &laquo;Попробуй&raquo;?</h1>
    <p>
      Вашим новым гостям бывает трудно определиться с выбором в первый раз. Раздел
      &laquo;Попробуй&raquo; это, фактически, ваша витрина: это те блюда, которые гость увидит сразу
      при заходе в ваше меню из приложения.
    </p>
    <p>Мы советуем предлагать:</p>
    <ul>
      <li>ваши фирменные блюда</li>
      <li>ваши самые популярные блюда</li>
      <li>новинки</li>
    </ul>
    <p>Можете расставлять блюда в любом порядке.</p>
    <p>
      <i>Это окно всегда можно вызвать, нажав на иконку вопроса рядом с меню.</i>
    </p>
  </div>
);

export const GiftsHint = () => (
  <div>
    <p>
      Все мы любим возвращаться в те места, с которыми нас что-то связывает. Раздел
      <strong> Подарки </strong>
      позволяет вам создать такую связь с вашим новым гостем — предложите ему подарок после первого
      заказа и увеличьте шанс того, что он вернется!
    </p>
    <p>
      Подарки работают так:
      <ol>
        <li>Гость оплачивает первый заказ в вашем заведении.</li>
        <li>Он получает возможность выбрать один из предложенных вами подарков.</li>
        <li>
          При следующем посещении вашего заведения гость получит подарок бесплатно к своему заказу.
        </li>
      </ol>
    </p>
    <p>
      На роль подарков отлично подойдут не очень трудоемкие в приготовлении и недорогие напитки или
      блюда.
    </p>
    <p>
      Возможность получить подарок будет только у тех гостей, кто пока что сделал у вас только ровно
      один заказ. Вы также можете включать и отключать подарки в любой момент в этом разделе.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/hints.js